import React from 'react'

import SendMessage, { SendMessagePayload, Props as SendMessageProps } from '@/app/component/send/message-dialog'
import { useGetSenderOptions } from '@/app/module/common/hooks/use-get-sender-options'
import { useSendMessage } from '@/app/module/common/hooks/use-send-message'
import { PersonalizationType } from '@/app/types'

export type SendMessageSelectionProps = Omit<
  SendMessageProps,
  'closeHandler' | 'isOpen' | 'personalizationList' | 'sendMessage' | 'senderIds' | 'senderIdsLoading' | 'senderId'
>

type Props = {
  isOpen: boolean
  personalizationList?: PersonalizationType
  sendMessageProps: SendMessageSelectionProps
  senderId?: SendMessageProps['senderId']
  onClearSelection: () => void
  onClose: () => void
}

const SendMessageDialog: React.FC<Props> = ({
  isOpen,
  personalizationList,
  sendMessageProps,
  senderId,
  onClearSelection,
  onClose,
}) => {
  const [sendMessage] = useSendMessage()
  const { senderIds, isLoading } = useGetSenderOptions()

  const handleSendMessage = React.useCallback(
    async (payload: SendMessagePayload) => {
      const success = await sendMessage(payload)
      if (success) {
        onClearSelection()
      }
    },
    [onClearSelection, sendMessage],
  )

  if (!isOpen) {
    return null
  }

  return (
    <SendMessage
      {...sendMessageProps}
      isOpen
      personalizationList={personalizationList}
      senderId={senderId}
      senderIds={senderIds}
      senderIdsLoading={isLoading}
      closeHandler={onClose}
      sendMessage={handleSendMessage}
    />
  )
}

export type { Props as SendMessageDialogProps }
export default SendMessageDialog
